import React from 'react';
import PropTypes from 'prop-types';
import { RaisedButton, IconButton } from 'material-ui';
import Add from 'material-ui/svg-icons/content/add';
import { StyleSheet, css } from 'aphrodite';

import OurismanTravelTheme from '../../ourismanTravelTheme';

export default class NewInquiryButton extends React.Component {
  static propTypes = {
    history: PropTypes.shape({
      push: PropTypes.func,
    }).isRequired,
  }

  handleClick = () => {
    this.props.history.push('/inquiry/');
  };

  render() {
    return (<div>
      <div className={css(styles.large)}>
        <RaisedButton
          label='New Inquiry'
          primary
          onClick={this.handleClick}
          icon={<Add />}
        />
      </div>
      <div className={css(styles.small)}>
        <IconButton onClick={this.handleClick}>
          {<Add color={OurismanTravelTheme.palette.alternateTextColor} />}
        </IconButton>
      </div>
    </div>);
  }
}

const styles = StyleSheet.create({
  large: {
    '@media (max-width: 800px)': {
      display: 'none',
    },
  },
  small: {
    '@media (min-width: 800px)': {
      display: 'none',
    },
  },
});



// WEBPACK FOOTER //
// /src/components/Container/NewInquiryButton.js